export default __webpack_public_path__ + "static/clock1-1faffb7964ddcb8644a4125aef324362.svg";